import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PageNotAuthorized } from '../navigation/ErrorHandling';
import { DefaultHeader, ListCaseStudies, ListNotifications, ListS3Files } from '../parts/Parts';
import { signOutUser } from '../../_redux/actions/AuthActions';
import { useDispatch } from 'react-redux';

export const Dashboard = () => {
    const isAuth = useSelector((state) => state.auth.isAuthenticated);
    const dispatch = useDispatch();

    return (
        <>

            {isAuth ? (
                <>
                    <DefaultHeader defaultHeader="Dashboard" />
                    <div className="component dashboard-component">

                        <div className="row dashboard--one">
                            <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                {isAuth ? <Link onClick={() => dispatch(signOutUser())}>Sign Out</Link> : ''}
                            </div>
                            <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6">

                            </div>
                        </div>

                        <div className="row dashboard--one">
                            <div className="col col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                <ListNotifications />
                            </div>
                            <div className="col col-xs-12 col-sm-8 col-md-8 col-lg-8">
                                <ListCaseStudies />
                            </div>
                        </div>

                        <div className="row dashboard--two">
                            <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                {/* Display Deployment Infromation */}
                            </div>
                            <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            </div>
                        </div>

                        <div className="row dashboard--three">
                            <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                {/* <ListS3Files /> */}
                            </div>
                            <div className="col col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            </div>
                        </div>

                    </div>

                </>
            ) : (<PageNotAuthorized />)}
        </>
    );
}

